import { isDefined } from "@clipboard-health/util-ts";
import { useCurrentDate } from "@src/appV2/lib/utils/useCurrentDate";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { parseISO } from "date-fns";

import { useWorkerEtaImprovementsConfig } from "../../ClipboardScore/hooks/useWorkerEtaImprovementsConfig";
import { useNextTwoDaysShifts } from "../../WorkerShifts/api/useNextTwoDaysShifts";
import { findShiftEligibleForTrip } from "./findShiftEligibleForTrip";
import { findTripEligibleForEtaNudge } from "./findTripEligibleForEtaNudge";
import { useGetWorkerTrips } from "./useGetWorkerTrips";

export function useEtaNudgeData() {
  const worker = useDefinedWorker();
  const { isEtaNudgeEnabled, stationaryMinutesThresholdForEtaNudge, isLateThresholdMinutes } =
    useWorkerEtaImprovementsConfig();
  const now = useCurrentDate(1000);

  const { data: nextTwoDaysShiftsData } = useNextTwoDaysShifts(worker.tmz ?? "", {
    enabled: isEtaNudgeEnabled && isDefined(worker.tmz),
  });

  const shiftEligibleForTrip = findShiftEligibleForTrip({
    shifts: nextTwoDaysShiftsData?.response ?? [],
    currentDate: now,
  });

  const { data: tripsData } = useGetWorkerTrips(
    { shiftId: shiftEligibleForTrip?._id ?? "" },
    {
      enabled:
        isEtaNudgeEnabled &&
        isDefined(shiftEligibleForTrip?._id) &&
        isDefined(shiftEligibleForTrip?.facility.userId),
    }
  );

  const trip =
    isDefined(shiftEligibleForTrip?.start) && isDefined(tripsData)
      ? findTripEligibleForEtaNudge({
          trips: tripsData,
          stationaryMinutesThresholdForEtaNudge,
          shiftStartDateIso: shiftEligibleForTrip.start,
          targetArrivalTimeIso: shiftEligibleForTrip.computedArrival?.targetArrivalTime,
          currentDate: now,
          isLateThresholdMinutes,
        })
      : undefined;

  const shiftStartDate = isDefined(shiftEligibleForTrip?.start)
    ? parseISO(shiftEligibleForTrip.start)
    : undefined;
  const isOrientationBlockShift = isDefined(shiftEligibleForTrip?.orientationBlockId);

  const shouldShowEtaNudgeBottomSheet =
    isEtaNudgeEnabled &&
    isDefined(shiftEligibleForTrip) &&
    isDefined(shiftStartDate) &&
    isDefined(trip) &&
    !isOrientationBlockShift;

  return {
    shiftEligibleForTrip,
    trip,
    shiftStartDate,
    shouldShowEtaNudgeBottomSheet,
  };
}
